import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useAddDeviceToCalendar = ({ calendar, onFetchCalendar }) => {
  const { onSubmit: handleAddDevice } = useFetch(
    'calendar-add-device',
    Api.CALENDAR_ADD_DEVICE
  );

  const onAddDeviceToCalendar = (ids, onSuccess) =>
    handleAddDevice({
      body: ids,
      pathParams: { id: calendar.id },
      onSuccess: () => {
        onSuccess();
        onFetchCalendar();
      },
    });

  return {
    onAddDeviceToCalendar,
  };
};

export default useAddDeviceToCalendar;
